var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_9_70969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1869 11H32.0415C34.2284 11 35.9723 12.7716 35.9723 14.9308V16.7855H30.1869V11ZM30.2145 20.1072H35.9999V25.8927H30.2145V20.1072ZM30.2145 34.9723H32.0691C34.256 34.9723 35.9999 33.2007 35.9999 31.0415V29.1869H30.2145V34.9723ZM15.9308 34.9722C13.7716 34.9722 12 33.2283 12 31.0414V29.2145H17.7855V34.9722H15.9308ZM17.7855 20.1072H12V25.8927H17.7855V20.1072ZM12 16.7855V14.9308C12 12.7716 13.7716 11 15.9308 11H26.8927V35H21.1073V16.7855H12Z",
    fill: "url(#paint0_linear_9_70969)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_9_70969",
    x: 0.58461,
    y: 0.726149,
    width: 46.8307,
    height: 46.8308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.7077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.192157 0 0 0 0 0.905882 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_70969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_70969",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.42462
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71231
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_9_70969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_70969",
    x1: 24,
    y1: 11,
    x2: 24,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD56FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A29E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipPurple);
export default __webpack_public_path__ + "static/media/chip-purple.c943f9be5af92f7fd94c2039e70086de.svg";
export { ForwardRef as ReactComponent };